export interface ListItem {
    label: string;
    value: string;
}